import api from "../../utils/ApiConfig";

export const fetchReasons = async () => {
  const response = await api.get("/bo/delivery-issue-reasons");
  return response.data;
};

export const createReason = async (data) => {
  const response = await api.post("/bo/delivery-issue-reasons", data);
  return response.data;
};

export const updateReason = async (id, data) => {
  const response = await api.put(`/bo/delivery-issue-reasons/${id}`, data);
  return response.data;
};
